<template>
  <v-navigation-drawer disable-resize-watcher v-model="isOpen" app color="primary" class="darken-1">
    <div class="d-flex justify-center mt-3 mb-4">
      <v-img contain max-height="90" transition="scale-transition" alt="TinyGS logo" src="../../assets/logo.svg" />
    </div>
    <v-divider color="white"></v-divider>
    <v-list dense>
      <v-list-item-group flat class="white--text">
        <v-list-item dark v-for="link in links" :key="link.text" router :to="link.path">
          <v-list-item-icon>
            <v-icon>{{ link.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ link.text }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-group dense
          :value="false"
          prepend-icon="$satellite"
          no-action
          sub-group>
          <template v-slot:activator>
            <v-list-item-content flat class="white--text">
              <v-list-item-title dark>Satellites</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item dark v-for="link in satellites" :key="link.text" router :to="link.path">
            <v-list-item-content>
              <v-list-item-title>{{ link.text }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>

        <v-list-group dense
          :value="false"
          prepend-icon="$rotateOrbit"
          no-action
          sub-group>
          <template v-slot:activator>
            <v-list-item-content flat class="white--text">
              <v-list-item-title>About</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item dark v-for="link in about" :key="link.text" router :to="link.path">
            <v-list-item-content>
              <v-list-item-title>{{ link.text }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </v-list-item-group>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { defineComponent, ref, computed } from 'vue';

export default defineComponent({
  name: "NavDrawer",
  props: {
    value: {
      type: Boolean,
      required: true
    }
  },
  setup(props, { emit }) {
    const links = ref([
      { text: 'Home', icon: 'mdi-home', path: '/' },
      { text: 'Stations', icon: '$station', path: '/stations' },
      { text: 'Packets', icon: 'mdi-file-document-outline', path: '/packets' },
    ]);
    const satellites = ref([
      { text: 'Active Satellites', icon: '$satellite', path: '/satellites' },
      { text: 'FSK Satellites', icon: '$satellite', path: '/satellitesFSK' },
      { text: 'Starlink Satellites', icon: '$satellite', path: '/satellitesSL' },
      { text: 'Inactive Satellites', icon: '$satellite', path: '/satellitesIna' },
      { text: 'Future Satellites', icon: '$satellite', path: '/satellitesFut' },
      { text: 'Surveillance Mode', icon: '$satellite', path: '/satellitesSurv' },    
      { text: 'Balloons', icon: '$balloon', path: '/balloons' },
    ]);
    const about = ref([
      { text: 'Meet the team', icon: 'mdi-home', path: '/about' },
      { text: 'History', icon: '$station', path: '/history' },
      { text: 'Terms', icon: '$station', path: '/terms' },
    ]);

    const isOpen = computed({
      get: () => props.value,
      set: (val) => emit('input', val)
    });

    return {
      links,
      satellites,
      about,
      isOpen
    };
  }
});
</script>